import { render, staticRenderFns } from "./SpaceSettingsDelete.vue?vue&type=template&id=6ad82712&"
import script from "./SpaceSettingsDelete.vue?vue&type=script&lang=js&"
export * from "./SpaceSettingsDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports